export default __webpack_public_path__ + "static/media/jpeg.47ff7963.svg";